import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { useQuery, useMutation } from "react-apollo-hooks";
import AsyncSelect from "react-select/async";
import { toast } from "react-toastify";
import NumberFormat from "react-number-format";
import {
  MANAGER_FEE_DETAIL_QUERY,
  MANAGER_FEEHASUSER_LIST_QUERY,
  MANAGER_FEEHASUSER_EXCLUSIVE_QUERY,
  MANAGER_FEEHASUSER_WRITE_QUERY,
  MANAGER_FEEHASUSER_DELETE_QUERY,
  MANAGER_FEEHASUSER_EDIT_QUERY,
} from "../../Queries";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../Components/Panel/Panel";
import { feeStatusBadge } from "../../../../Components/Fee/feeStatusBadge";
import {
  feeValueArray,
  feeDayArray,
} from "../../../../Components/User/UserNames";
import PaymentHistory from "../PaymentHistory";
import FeeHasUserEditModal from "../../../../Components/Fee/FeeHasUserEditModal";
import { graphqlUri } from "../../../../Config/Env";

const UserSearch = ({ feeId, onSelect }) => {
  const [keyword, setKeyword] = useState("");
  const { data, loading } = useQuery(MANAGER_FEEHASUSER_EXCLUSIVE_QUERY, {
    variables: { fee_id: feeId, keyword },
    fetchPolicy: "network-only",
  });

  const loadOptions = (inputValue, callback) => {
    if (
      !loading &&
      data &&
      data.ManagerFeeHasUserExclusiveUserList &&
      data.ManagerFeeHasUserExclusiveUserList.users
    ) {
      callback(
        data.ManagerFeeHasUserExclusiveUserList.users.map((u) => ({
          value: u.id,
          label: `${u.name}(${u.userId})`,
        }))
      );
    } else {
      callback([]);
    }
  };
  const handleInputChange = (value) => {
    setTimeout(() => setKeyword(value), 500);
  };

  return (
    <AsyncSelect
      placeholder="이름/아이디 검색"
      noOptionsMessage={() => "이름 또는 아이디를 검색해주세요."}
      isClearable
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={(option) => onSelect(option ? option.value : "")}
    />
  );
};

export default withRouter(({ match, location }) => {
  const feeId = match.params.feeId;

  const { data: feeData } = useQuery(MANAGER_FEE_DETAIL_QUERY, {
    variables: { id: feeId },
  });
  const { data, loading, refetch } = useQuery(MANAGER_FEEHASUSER_LIST_QUERY, {
    variables: { feeId, skip: 0, first: 1000 },
    fetchPolicy: "network-only",
  });

  const [writeMutation] = useMutation(MANAGER_FEEHASUSER_WRITE_QUERY);
  const [deleteMutation] = useMutation(MANAGER_FEEHASUSER_DELETE_QUERY);

  const [userId, setUserId] = useState("");
  const [feeDay, setFeeDay] = useState("5");
  const [feeValue, setFeeValue] = useState("");

  const onAdd = async () => {
    if (!userId) return toast.error("회원을 검색해 선택해주세요.");
    if (!feeValue || parseInt(feeValue) <= 0)
      return toast.error("출금금액을 입력해주세요.");
    try {
      const {
        data: { ManagerFeeHasUserWrite },
      } = await writeMutation({
        variables: { user_ids: [userId], fee_id: feeId, feeDay, feeValue },
      });
      if (ManagerFeeHasUserWrite) {
        toast.success("회원이 추가되었습니다.");
        setUserId("");
        setFeeValue("");
        refetch();
      } else {
        toast.error("처리에 실패했습니다.");
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  const onDelete = async (id) => {
    if (
      !window.confirm(
        "이 회원을 탈퇴시키겠습니까?\n\n회원 납부내역은 모두 삭제되며, 재가입 시 초기화됩니다.\n단, 이미 출금된 거래내역(출금 기록)은 회계상 보존되어 남습니다."
      )
    )
      return;
    try {
      const {
        data: { ManagerFeeHasUserDelete },
      } = await deleteMutation({ variables: { id } });
      if (ManagerFeeHasUserDelete) {
        toast.success("탈퇴되었습니다.");
        refetch();
      } else {
        toast.error("처리에 실패했습니다.");
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  const feeTitle =
    feeData && feeData.ManagerFeeDetail ? feeData.ManagerFeeDetail.title : "";

  const onDownloadUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${graphqlUri}/excels/feeUsers?feeId=${feeId}`, {
        method: "POST",
        mode: "cors",
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      if (!res.ok) {
        const msg = await res.text();
        toast.error(msg || "엑셀 다운로드에 실패했습니다.");
        return;
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `회원목록_${feeTitle || feeId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      a.remove();
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  return (
    <>
      <Helmet>
        <title>회원목록 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to={`/manager/fees${location.search}`}>담당 회비</Link>
          </li>
          <li className="breadcrumb-item active">회원목록</li>
        </ol>
        <h1 className="page-header">{feeTitle} 회원목록</h1>

        <div className="m-b-15">
          <Link to={`/manager/fees${location.search}`} className="btn btn-white">
            <i className="fa fa-list m-r-5"></i>목록
          </Link>
        </div>

        <Panel>
          <PanelHeader noButton={true}>회원 추가</PanelHeader>
          <PanelBody>
            <div className="alert alert-info f-s-13 m-b-10">
              <i className="fa fa-info-circle m-r-5"></i>
              회원을 추가하면 해당 사용자에게 <b>가입 안내 알림</b>이
              전송됩니다.
            </div>
            <div className="row">
              <div className="col-md-5 m-b-5">
                <UserSearch feeId={feeId} onSelect={setUserId} />
              </div>
              <div className="col-md-2 m-b-5">
                <select
                  className="form-control"
                  value={feeDay}
                  onChange={(e) => setFeeDay(e.target.value)}
                >
                  {feeDayArray.map((d) => (
                    <option key={d} value={d}>
                      {d}일
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 m-b-5">
                <select
                  className="form-control"
                  value={feeValue}
                  onChange={(e) => setFeeValue(e.target.value)}
                >
                  <option value="">출금금액 선택</option>
                  {feeValueArray.map((v) => (
                    <option key={v} value={v}>
                      {v.toLocaleString()} 드림
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2 m-b-5">
                <button
                  className="btn btn-primary btn-block"
                  onClick={onAdd}
                >
                  추가
                </button>
              </div>
            </div>
          </PanelBody>
        </Panel>

        <div className="alert alert-primary f-s-13 m-b-15">
          <strong className="f-s-15">※ 주의사항(필독)</strong>
          <br /> * 탈퇴 : 탈퇴 시 회비 회원목록에서 제외되며, 회원 납부내역이 모두
          삭제됩니다. 재가입 시 납부내역은 초기화됩니다.
          <br /> * 단, 이미 출금된 거래내역(출금 기록)은 회계상 보존되어 삭제되지
          않습니다. 탈퇴 후에도 거래내역에는 출금금액이 남아 있을 수 있습니다.
        </div>

        <Panel>
          <PanelHeader noButton={true}>
            회원 목록
            <button
              className="btn btn-white btn-xs pull-right"
              onClick={onDownloadUsers}
            >
              <i className="fa fa-download m-r-5"></i>회원목록 다운로드
            </button>
          </PanelHeader>
          <PanelBody className="p-0">
            <div className="table-responsive">
              <table className="table table-bordered table-striped m-b-0">
                <thead>
                  <tr>
                    <th>회원</th>
                    <th>상태</th>
                    <th>출금일</th>
                    <th>출금금액</th>
                    <th>미납금액</th>
                    <th>납부총액</th>
                    <th style={{ width: 190 }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {(!data ||
                    loading ||
                    data.ManagerFeeHasUserList.feeHasUsers.length === 0) && (
                    <tr>
                      <td colSpan={7} className="text-center">
                        {loading ? "불러오는 중..." : "회원이 없습니다."}
                      </td>
                    </tr>
                  )}
                  {data &&
                    !loading &&
                    data.ManagerFeeHasUserList.feeHasUsers.map((f) => (
                      <tr key={f.id}>
                        <td>
                          <i
                            className="fa fa-circle f-s-7 fa-fw m-r-5"
                            style={{
                              color:
                                f.user.commonStatus === "C" &&
                                f.user.confirmed === true
                                  ? "#00acac"
                                  : "#ff5b57",
                            }}
                          />
                          {f.user.name}({f.user.userId})
                          {f.user.blocked ? (
                            <i className="fa fa-lock f-s-10 fa-fw m-l-5 text-red" />
                          ) : (
                            ""
                          )}
                        </td>
                        <td>{feeStatusBadge(f.commonStatus)}</td>
                        <td>{f.feeDay}일</td>
                        <td align="right">
                          <NumberFormat
                            value={f.feeValue}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </td>
                        <td align="right" className="text-red">
                          <NumberFormat
                            value={f.feeDefault}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </td>
                        <td align="right">
                          <NumberFormat
                            value={f.feeAmount}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </td>
                        <td align="center">
                          <PaymentHistory
                            feeHasUserId={f.id}
                            memberName={`${f.user.name}(${f.user.userId})`}
                          />
                          <FeeHasUserEditModal
                            feeHasUser={f}
                            memberName={`${f.user.name}(${f.user.userId})`}
                            mutation={MANAGER_FEEHASUSER_EDIT_QUERY}
                            resultKey="ManagerFeeHasUserEdit"
                            onDone={refetch}
                          />
                          <button
                            className="btn btn-white btn-xs text-red"
                            onClick={() => onDelete(f.id)}
                          >
                            탈퇴
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </>
  );
});
